import { Col, Row } from 'ui';
import variables from 'common/styles/variables.json';
import { ContinueInBrowserButton } from './continue-in-browser-button';
import { usePlatformAssets } from './hooks';
import { StoreButton } from './store-button';
import { WelcomeHeader } from './welcome-header';

export type MobilePlatform = 'android' | 'ios';

type P = {
  onContinueInBrowser: () => void;
  platform: MobilePlatform;
};

const RedirectToMobileApp = ({ onContinueInBrowser, platform }: P) => {
  const { additionalTitle, button, info } = usePlatformAssets({ platform });

  const onClick = () => {
    onContinueInBrowser();
  };

  return (
    <Row gutter={[0, variables.spaceXs.value * 13]} justify="center">
      <Col span={24}>
        <Row gutter={[0, variables.spaceXs.value * 5]}>
          <Col span={24}>
            <WelcomeHeader additionalTitle={additionalTitle} />
          </Col>
          <Col span={24}>
            <StoreButton button={button} info={info} />
          </Col>
        </Row>
      </Col>

      <Col span={24}>
        <ContinueInBrowserButton onClick={onClick} />
      </Col>
    </Row>
  );
};

export default RedirectToMobileApp;
